import React from "react";
import cx from "classnames";
import {AiFillCaretDown, AiFillCaretUp, AiFillFilter, AiOutlineFilter} from "react-icons/ai";

type TableHeaderColumnProps = {
    className?: string;
    contentClassName?: string;
    label: string | JSX.Element;
    isSorted?: boolean;
    isSortedDescending?: boolean;
    isSortable?: boolean;
    isFiltered?: boolean;
    isFilterable?: boolean;
    onClick?: () => void;
    onFilterButtonClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
};

export function TableHeaderColumn(props: TableHeaderColumnProps) {
    const sortable = props.isSortable ?? true;
    const isSorted = props.isSorted ?? false;
    const isSortedDescending = props.isSortedDescending ?? false;
    const filterable = props.isFilterable ?? false;
    const headerClassName = props.className ?? '';
    const contentClassName = props.contentClassName ?? '';

    return (
        <th className={cx("text-left text-sm font-medium tracking-wider dark:text-gray-300", 'px-4 py-2 text-left text-xs font-medium tracking-wider dark:text-gray-300', 'whitespace-nowrap', headerClassName)}>
            <div className={['resize-x overflow-hidden', contentClassName].join(' ')}>
                {/* eslint-disable-next-line react/no-unknown-property */}
                <style jsx>{`
                  //noinspection ALL
                  .resize-x {
                    min-width: -webkit-fill-available;
                    min-width: -moz-available;
                    min-width: fill-available;
                  }
                `}</style>
                <div
                    className={cx('flex items-center gap-2', sortable ? 'cursor-pointer select-none' : 'cursor-default', 'pr-3', contentClassName)}
                    onClick={() => {
                        if (sortable) {
                            props.onClick?.();
                        }
                    }}
                >
                    {/* Filter button, as narrow as possible */}
                    <span className="flex items-center justify-center w-4 h-4"
                          onClick={(e) => {
                              e.stopPropagation();
                              props.onFilterButtonClick?.(e);
                          }}>
                        {filterable && (!props.isFiltered &&
                            <AiOutlineFilter className="w-4 h-4 text-gray-400 animate-pulse"/> ||
                            <AiFillFilter className="w-4 h-4 text-gray-400"/>)}
                    </span>
                    {/* Column name */}
                    <span className="overflow-ellipsis overflow-hidden max-w-[200px]">{props.label}</span>
                    {/* Sorting arrow */}
                    {sortable && <span className="ml-2">
                        {isSorted && isSortedDescending && <AiFillCaretDown/>}
                        {isSorted && !isSortedDescending && <AiFillCaretUp/>}
                    </span>}
                </div>

            </div>
        </th>);
}
